export const API_EXTERNAL_ENDPOINT = 'blog/posts'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/blog/posts/list'
